import { TextFieldElement } from "../widgets/Form/TextFieldElement";
import { Button } from "@mui/material";

import IconArrowLeftShort from "../icons/IconArrowLeftShort";
import { useContext, useEffect, useState } from "react";
import IconPen from "../icons/IconPen";
import { ModalContext } from "../../context/context";
import { useFormContext } from "@graphcommerce/ecommerce-ui";
import { useMutation, useQuery } from "@graphcommerce/graphql";
import { createAccountOTPVerifyDocument } from "../../graphql/login/createAccountOtpVerify.gql";
import { useLoading } from "../../context/loadingContext";
import { loginOTPVerifyDocument } from "../../graphql/login/loginOTPVerify.gql";
import { createCustomerAccountDocument } from "../../graphql/login/createCustomerAccount.gql";
import useLogin from "./useLogin";

export default function SendCodeForm({ setActiveForm, data, stayAtPage }: { setActiveForm: (a: string) => void, data: any, stayAtPage?: boolean }) {
  const [counter, setCounter] = useState(120);
  const useModal = useContext(ModalContext);
  const { refetch } = useQuery(createAccountOTPVerifyDocument, { skip: true });
  const { refetch: verifyCode } = useQuery(loginOTPVerifyDocument, { skip: true });
  const [createCustomerAccount] = useMutation(createCustomerAccountDocument)
  const methods = useFormContext();
  const { setLoading } = useLoading();
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [successMessage, setSuccessMessage] = useState<any>(null);
  const { handleLogin } = useLogin();
  useEffect(() => {
    const counterHandler = () => {
      counter > 0 && setCounter(counter - 1);
    }
    const h = setTimeout(counterHandler, 1000);

    return () => clearInterval(h)
  });

  const handleSubmit = (values) => {
    setLoading(true);
    if (data.mode == 'createAccount') {
      refetch({
        mobileNumber: data.mobileNumber,
        otp: values.otp
      }).then(({ data: { createAccountOTPVerify }, errors }) => {
        if (!errors) {
          if (createAccountOTPVerify?.status === false) {
            setErrorMessage(createAccountOTPVerify.message)
          } else {
            createCustomerAccount({
              variables: {
                firstname: data.firstname,
                lastname: data.lastname,
                date_of_birth: data.date_of_birth,
                email: data.email,
                gender: data.gender,
                mobileNumber: data.mobileNumber,
                password: data.password,
                otp: values.otp
              }
            }).then(({ data }) => {
              if (data?.createCustomerAccount?.status === true && data.createCustomerAccount.token) {
                setSuccessMessage(createAccountOTPVerify?.message ?? 'عملیات ثبت نام با موفقیت انجام شد.');
                handleLogin(data.createCustomerAccount.token, null, true, stayAtPage)
              }
            }).catch(err => setErrorMessage(err.message)).finally(() => setLoading(false))
          }
          setLoading(false);
        }
      })
    } else if (data.mode == 'loginOtp') {
      verifyCode({
        mobileNumber: data.mobileNumber,
        otp: values.otp
      }).then(({ data: { loginOTPVerify }, errors }) => {
        if (loginOTPVerify?.status === true && loginOTPVerify.token) {
          handleLogin(loginOTPVerify.token)
          setSuccessMessage('ورود با موفقیت انجام شد.')
          setErrorMessage(null)
        } else {
          setErrorMessage(loginOTPVerify?.message)
        }
      }).catch(err => setErrorMessage(err.message)).finally(() => setLoading(false));
    } else {
      setActiveForm('signup');

    }
  }
  return (
    <div className="pt-16 md:pt-5">
      {errorMessage && <div className="text-sm text-error-500 font-normal text-center my-4">
        {errorMessage}
      </div>}
      {successMessage && <div className="text-sm text-secondary-300 font-normal text-center my-4">
        {successMessage}
      </div>}
      <p className="text-base font-medium">احراز شماره تلفن همراه</p>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <p className="text-xs text-light-400">لطفاً کد ارسال‌شده از طریق پیامک را در قسمت زیر وارد نمایید:</p>
        <TextFieldElement
          name="otp"
          label="کد ۵ رقمی"
          required
          fullWidth
          type="otp"
          variant='standard'
          classes={{ root: "!mt-5" }}
          className="!text-sm"
          color='primary' />

        <div className="flex justify-center items-center mt-4">
          {counter > 0 ? <p>   امکان ارسال مجدد کد تا <span>{counter}</span> ثانیه دیگر</p> :

            <Button type="button" variant="text" color="primary" className="flex justify-center text-primary-500">
              ارسال مجدد کد
            </Button>}
        </div>

        <div className="flex justify-center items-center mt-4">
          <Button type="submit" variant="contained" color="secondary" className="flex justify-center bg-secondary-500">
            تأیید نهایی
          </Button>
        </div>

        <div className="mt-7 flex justify-between">
          <Button type="button" className="text-light-400 !rounded-sm" onClick={() => data && data.mode === 'createAccount' ? setActiveForm('signup') : setActiveForm('code')}>
            <IconPen width={14} height={14} />
            تغییر شماره تلفن همراه
          </Button>

          <Button type="button" className="text-light-400 !rounded-sm" onClick={() => useModal.close && useModal.close()}>
            بستن
            <IconArrowLeftShort width={18} height={18} />
          </Button>
        </div>
      </form>
    </div>
  )
}